import { AssessModel } from "domains/models/AssessModel";
import { EmployeeModel } from "domains/models/EmployeeModel";
import { UserModel } from "domains/models/UserModel";
import M5APIs from "m5/M5APIs";
import { M5User } from "m5/models/M5User";
import { makeAutoObservable, action, computed, observable } from "mobx";
import moment from "moment";
import * as config from "../../../_config";

class AdvicePageStore {
  @observable private _containers = [];

  @observable private _isLoading: boolean = false;
  @observable private _total = 0;
  @observable private _employeeList: Array<EmployeeModel> = [];
  @observable private _tabValue: string = "downwards";

  @observable private _isOpenModal: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async fetchTargetsByDeptCode(userInfo: UserModel | undefined) {
    try {
      this._isLoading = true;
      let response;
      if (this._tabValue === "downwards") {
        console.log('DOWNWARDS', this._tabValue);
        let tempIdlist = userInfo?.userData.downwardsList?.map((li) => li.id);
        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "meta().id",
                compare: "IN",
                value: tempIdlist ? tempIdlist : [],
              },
            ],
          }),
          linkedIds: "SVCDoc_1018837317619712",
        });
      } else if (this._tabValue === "peer") {
        console.log('PEER', this._tabValue);
        let tempIdlist = userInfo?.userData.peerList?.map((li) => li.id);
        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "meta().id",
                compare: "IN",
                value: tempIdlist ? tempIdlist : [],
              },
            ],
          }),
        });
      } else {
        let tempIdlist1: any = userInfo?.userData.downwardsList?.map(
          (li) => li.id
        );
        let tempIdlist2: any = userInfo?.userData.peerList?.map((li) => li.id);
        if (!tempIdlist1) {
          tempIdlist1 = [];
        }
        if (!tempIdlist2) {
          tempIdlist2 = [];
        }

        let tempIdlist = [...tempIdlist1, ...tempIdlist2];
        console.log(tempIdlist);

        response = await M5APIs.fetchUsers({
          fetchByFieldValue: "aggregationId",
          page: 0,
          pageSize: 20000,
          where: JSON.stringify({
            filters: [
              {
                condition: "AND",
                field: "meta().id",
                compare: "IN",
                value: tempIdlist ? tempIdlist : [],
              },
            ],
          }),
        });
      }

      console.log(response);

      // for (let i = 0; i < response.users.length; i++) {}
      if (response?.users) {
        for (let i = 0; i < response.users.length; i++) {
          for (let j = 0; j < response.children.length; j++) {
            if (
              response.users[i].userData.aggregationId ===
              response.children[j].id
            ) {
              let sum = 0;
              let count = 0;
              let avg = 0;
              if (response.children[j].userData.assessList) {
                for (
                  let k = 0;
                  k < response.children[j].userData.assessList.length;
                  k++
                ) {
                  if (
                    response.children[j].userData.assessList[k]?.subtype ===
                    "INVISIBLE"
                  ) {
                    count = count + 1;
                    sum =
                      sum +
                      Number(
                        response.children[j].userData.assessList[k]?.userData
                          ?.grade
                      );
                  }
                }

                avg = count === 0 ? 0 : sum / count;
              }
              response.users[i].userData = {
                ...response.users[i].userData,
                avg: avg,
              };
            }
          }
        }
      } else {
        this._employeeList = response?.users;
        this._total = response?.total;
        return response;
      }

      // for (let i = 0; i < response.users.length; i++) {
      //   const assessRes: any = await M5APIs.fetchDocs(
      //     config.BUCKET_TASK!,
      //     "ASSESS",
      //     {
      //       where: {
      //         filters: [
      //           {
      //             condition: "AND",
      //             field: "userId",
      //             compare: "=",
      //             value: response.users[i].id,
      //           },
      //           {
      //             condition: "AND",
      //             field: "created",
      //             compare: "BETWEEN",
      //             value: [
      //               moment().subtract(1, "month").valueOf(),
      //               moment().valueOf(),
      //             ],
      //           },
      //         ],
      //       },
      //     }
      //   );
      //   let sum = 0;
      //   let avg = 1;
      //   if (assessRes.docs) {
      //     for (let i = 0; i < assessRes.docs.length; i++) {
      //       sum = sum + assessRes.docs[i]?.userData?.grade;
      //     }
      //     avg = sum / assessRes.docs?.length;
      //   }
      //   response.users[i].userData = {
      //     ...response.users[i].userData,
      //     avg: avg,
      //   };
      // }

      // 우선 평균값이 존재하는 배열 / 존재하지않는 배열 구분
      let filterUserHasAvg = response.users.filter(
        (user: EmployeeModel) => user.userData.avg
      );
      let filterUserHasnotAvg = response.users.filter(
        (user: EmployeeModel) => !user.userData.avg
      );

      // 평균값이 존재하는 배열에서 영어이름 배열, 아닌 배열 구분
      let filterUserHasAvgEng = filterUserHasAvg.filter((user: EmployeeModel) =>
        this.isEnglishName(user.names.fullname)
      );
      let filterUserHasAvgKor = filterUserHasAvg.filter(
        (user: EmployeeModel) => !this.isEnglishName(user.names.fullname)
      );

      // 정렬하기
      filterUserHasAvgEng.sort((a: any, b: any) =>
        a.names.fullname.localeCompare(b.names.fullname)
      );
      filterUserHasAvgKor.sort((a: any, b: any) =>
        a.names.fullname.localeCompare(b.names.fullname)
      );

      // 평균값이 존재하지 않는 배열에서 영어이름 배열, 아닌 배열 구분
      let filterUserHasnotAvgEng = filterUserHasnotAvg.filter(
        (user: EmployeeModel) => this.isEnglishName(user.names.fullname)
      );
      let filterUserHasnotAvgKor = filterUserHasnotAvg.filter(
        (user: EmployeeModel) => !this.isEnglishName(user.names.fullname)
      );

      // 정렬하기
      filterUserHasnotAvgEng.sort((a: any, b: any) =>
        a.names.fullname.localeCompare(b.names.fullname)
      );
      filterUserHasnotAvgKor.sort((a: any, b: any) =>
        a.names.fullname.localeCompare(b.names.fullname)
      );

      if (response) {
        this._employeeList = [
          ...filterUserHasAvgEng,
          ...filterUserHasAvgKor,
          ...filterUserHasnotAvgEng,
          ...filterUserHasnotAvgKor,
        ];
        this._total = response.total;
      }

      return response;
    } catch (err) {
      throw err;
    } finally {
      this._isLoading = false;
    }
  }

  isEnglishName(fullname: string): boolean {
    const regex = /^[a-zA-Z\s-]+$/;
    return regex.test(fullname);
  }

  @computed
  get total() {
    return this._total;
  }

  @action
  setTabValue(tabValue: string) {
    this._tabValue = tabValue;
  }
  @action
  setIsOpenModal(isOpenModal: boolean) {
    this._isOpenModal = isOpenModal;
  }

  @computed
  get employeeList() {
    return this._employeeList;
  }
  @computed
  get containers() {
    return this._containers;
  }
  @computed
  get isEmpty() {
    return this._containers.length === 0;
  }
  @computed
  get isOpenModal() {
    return this._isOpenModal;
  }
  @computed
  get isLoading() {
    return this._isLoading;
  }
  @computed
  get tabValue() {
    return this._tabValue;
  }
}

export default AdvicePageStore;
